import { FC } from "react";
import { StyleSheet, Text, TextStyle, TouchableOpacity, ViewStyle } from "react-native";
import { kStyleConst } from "src/kStyle";
import { CheckMarkBoxAnimated } from "./impComponents";

type tCheckMark2 = {
  myState?: boolean;
  onPress?: () => void;
  myText?: string;
  myLeaveSpace?: boolean;
  style?: ViewStyle | Array<ViewStyle>;
  textStyle?: TextStyle | Array<TextStyle>;
  textPlacement?: "left" | "right";
};

export const CheckMark2: FC<tCheckMark2> = ({
  myState,
  onPress,
  myText,
  myLeaveSpace = false,
  style,
  textPlacement,
  textStyle,
}) => {
  if (textPlacement === "left") {
    return (
      <TouchableOpacity style={[styles.gCheckMark2BoxContainer, style]} onPress={onPress}>
        <Text style={[styles.gApplyYesNoTextRight, textStyle]}>{myText}</Text>
        <CheckMarkBoxAnimated
          style={myLeaveSpace ? styles.gCheckMark2Box : styles.gApplyCheckMark2BoxNoMargin}
          mystate={myState ? "checked" : "unchecked"}
        />
      </TouchableOpacity>
    );
  }
  return (
    <TouchableOpacity style={[styles.gCheckMark2BoxContainer, style]} onPress={onPress}>
      <CheckMarkBoxAnimated
        style={myLeaveSpace ? styles.gCheckMark2Box : styles.gApplyCheckMark2BoxNoMargin}
        mystate={myState ? "checked" : "unchecked"}
      />
      <Text style={[styles.gApplyCheckMark2BoxTextLeft, textStyle]}>{myText}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  gApplyCheckMark2BoxNoMargin: {
    ...kStyleConst.kCheckBox,
  },
  gApplyCheckMark2BoxTextLeft: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  gApplyYesNoTextRight: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  gCheckMark2Box: {
    ...kStyleConst.kCheckBox,
    marginRight: 7 * kStyleConst.kSpacing,
  },
  gCheckMark2BoxContainer: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: 2 * kStyleConst.kSpacing,
  },
});
